module.exports = __webpack_public_path__ + "img/jaro-sykora.4ca398db.jpg";